import styled from 'styled-components';

export const Content = styled.div`
  width: 100%;
  height: 100%;
`;

export const BackButtonContainer = styled.div`
  margin-bottom: 48px;
`;
